'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_user_confirm', {
    url: '/admin/user_confirm/:token',
    template: '<oem-user-confirm></oem-user-confirm>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem_user_confirm/oem_user_confirm.routes.js